import Label from './Label';

export {
  Label,
};



// WEBPACK FOOTER //
// ./src/components/page/FloatLabelInput/components/index.js